import type { BoardId } from '@atlassian/jira-software-roadmap-model';

export const getEditFilterUrl = (boardId: BoardId): string =>
	`/secure/RapidBoard.jspa?rapidView=${boardId}&config=filter`;
